<template>
  <div class='EnbSlide'>
    <vueper-slides
    v-if="show"
    :autoplay="true"
    :fade="true"
    :arrows="false"
    :bullets="false"
    :fixed-height="true"
    >
      <vueper-slide
        v-for="(slide, i) in slides"
        :key="i"
        :image="api + slide.img">
      </vueper-slide>
    </vueper-slides>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import api from '@/mixins/api'
export default {
  name: 'EnbSlide',
  components: { VueperSlides, VueperSlide },
  mixins: [api],
  data () {
    return {
      slides: [],
      show: false
    }
  },
  methods: {
    ...mapActions(['GetFrenteLojaSlideImg'])
  },
  created () {
    this.GetFrenteLojaSlideImg()
      .then(res => {
        this.slides = res
        this.show = true
      })
  }
}
</script>

<style scoped>
.EnbSlide {
  height: 69%;
  background-color: #EEEEEE;
}

.vueperslides--fixed-height { height: 100%; }

@media (max-width: 500px) {
  .EnbSlide {
    height: 220px;
  }
  .vueperslides--fixed-height { height: 220px; }
}
</style>
